import { DetailPluginLock } from '../basic/interface_lock/DetailPluginLock';
import responseKeyNormalizerMapping from './mapping';
import InvestmentFunctionBarService from './service/InvestmentFunctionBarService';
import InvestmentOperationService from './service/InvestmentOperationService';
export default class InvestmentDetailPlugin extends DetailPluginLock {
    constructor() {
        super(responseKeyNormalizerMapping.pluginName);
        // @ts-ignore
        this.responseKeyNormalizerMapping = Object.freeze(responseKeyNormalizerMapping);
    }
    _queryParamsNormalizer(route) {
        return super._queryParamsNormalizer(route);
    }
    get ListOperationServiceClass() {
        return InvestmentOperationService;
    }
    get FunctionBarServiceClass() {
        return InvestmentFunctionBarService;
    }
    get basicInfo() {
        return {
            key: this.name,
            index: 5,
            label: `dataType.${this.name}`,
            entryRoute: { name: 'detailInvestmentRoot' },
        };
    }
    getPluginSubRouteConfig() {
        const self = this;
        function getDetailPageProps(location) {
            return {
                ...self.commonProps,
                ...self._queryParamsNormalizer(location),
            };
        }
        return {
            path: 'investment',
            name: 'detailInvestmentRoot',
            redirect: `${self.PLUGIN_BASIC_PATH}/${this.name}/folders`,
            // @ts-ignore
            component: () => import('./InvestmentDetail.vue'),
            props: getDetailPageProps,
            children: [
                {
                    path: 'folders',
                    name: 'investmentFolderPage',
                    // @ts-ignore
                    component: () => import('./plugin-view/Folder.vue'),
                    props: getDetailPageProps,
                },
            ],
        };
    }
}
